import { CockpitDocumentsAndLinks } from './CockpitDocumentsAndLinks'
import type { TDocumentType } from './types'

interface ICockpitDocumentsAndLinksExpandedProps {
  partnerId?: string
  isManagerCockpitMode?: boolean
  fullscreen?: boolean
  initialDocumentType?: TDocumentType
}

export const CockpitDocumentsAndLinksExpanded = ({
  partnerId,
  isManagerCockpitMode,
  fullscreen,
  initialDocumentType,
}: ICockpitDocumentsAndLinksExpandedProps) => (
  <CockpitDocumentsAndLinks
    expanded={true}
    initialDocumentType={initialDocumentType}
    fullscreen={fullscreen}
    partnerId={partnerId}
    isManagerCockpitMode={isManagerCockpitMode}
  />
)

CockpitDocumentsAndLinksExpanded.displayName = 'CockpitDocumentsAndLinksExpanded'
